/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

interface Props extends React.ClassAttributes<HTMLTableSectionElement> {
  children: React.ReactNode;
  borderBottom?: boolean;
}

export const TableBody = ({
  children,
  borderBottom = true,
  ...rest
}: Props) => {
  const tableBodyStyle = css`
    border-bottom: ${borderBottom ? "1px solid rgba(0, 0, 0, 0.08)" : "none"};
  `;

  return (
    <tbody css={tableBodyStyle} {...rest}>
      {children}
    </tbody>
  );
};
